import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

import TemplatePage from '@/common/Templates/TemplatePage'
import { PrivateRoute } from '@/components/Security/PrivateRoute'
import { isModuleEnabled } from '@/config/modules'
import { ROUTES } from '@/config/routes'
import { AppContextProvider } from '@/contexts/AppContext'
import { AuthProvider } from '@/contexts/AuthContext'
import { UserContextProvider } from '@/contexts/UserContext'
import Login from '@/pages/Login'
import LoginAccessDenied from '@/pages/Login/AccessDenied'
import LoginDevelopment from '@/pages/Login/Development'
import Panels from '@/pages/Panel/Panels'
import Predictions from '@/pages/Panel/Predictions'
import PredictionsResults from '@/pages/Panel/Predictions/Results'
import ProcessingPage from '@/pages/Panel/processing'
import ProcessingDetailsPage from '@/pages/Panel/processing/details'
import Sendings from '@/pages/Panel/Sendings'
import Users from '@/pages/Panel/Users'
import Profile from '@/pages/Profile'
import UserInfo from '@/pages/Users'
import { stringToBoolean } from '@/utils/string'

const App = () => {
  // Ativando processamento
  const hasDevLogin = stringToBoolean(process.env.REACT_APP_DEV_LOGIN)
  const defaultLanding = isModuleEnabled('predicoes')
    ? ROUTES.PREDICTIONS
    : isModuleEnabled('dashboard')
    ? ROUTES.DASHBOARD
    : isModuleEnabled('envios')
    ? ROUTES.SENDINGS
    : isModuleEnabled('perfil')
    ? ROUTES.PROFILE
    : ROUTES.LOGIN

  return (
    <AppContextProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="login">
              <Route index element={<Login />} />
              {hasDevLogin && (
                <Route path="desenvolvedor" element={<LoginDevelopment />} />
              )}
              <Route path="acesso-negado" element={<LoginAccessDenied />} />
            </Route>

            <Route
              path="/*"
              element={
                <UserContextProvider>
                  <Routes>
                    <Route path="/" element={<TemplatePage />}>
                      <Route element={<PrivateRoute />}>
                        {isModuleEnabled('dashboard') ? (
                          <Route path="dashboard" element={<Panels />} />
                        ) : (
                          <Route
                            path="dashboard/*"
                            element={<Navigate to="/" replace />}
                          />
                        )}

                        {isModuleEnabled('processamento') ? (
                          <Route path="processamento">
                            <Route index element={<ProcessingPage />} />
                            <Route
                              path="detalhes/:id"
                              element={<ProcessingDetailsPage />}
                            />
                          </Route>
                        ) : (
                          <Route
                            path="processamento/*"
                            element={<Navigate to="/" replace />}
                          />
                        )}

                        {isModuleEnabled('predicoes') ? (
                          <Route path="predicoes">
                            <Route index element={<Predictions />} />
                            <Route
                              path="resultado"
                              element={<PredictionsResults />}
                            />
                          </Route>
                        ) : (
                          <Route
                            path="predicoes/*"
                            element={<Navigate to="/" replace />}
                          />
                        )}

                        {isModuleEnabled('envios') ? (
                          <Route path="envios" element={<Sendings />} />
                        ) : (
                          <Route
                            path="envios/*"
                            element={<Navigate to="/" replace />}
                          />
                        )}

                        {isModuleEnabled('perfil') ? (
                          <Route path="perfil" element={<Profile />} />
                        ) : (
                          <Route
                            path="perfil/*"
                            element={<Navigate to="/" replace />}
                          />
                        )}
                      </Route>

                      <Route
                        element={<PrivateRoute allowedProfiles={['Admin']} />}
                      >
                        {isModuleEnabled('usuarios') ? (
                          <Route path="usuarios">
                            <Route index element={<Users />} />
                            <Route
                              path="editar/:userId"
                              element={<UserInfo />}
                            />
                          </Route>
                        ) : (
                          <Route
                            path="usuarios/*"
                            element={<Navigate to="/" replace />}
                          />
                        )}
                      </Route>

                      <Route index element={<Navigate to={defaultLanding} />} />
                    </Route>

                    <Route path="*" element={<Navigate to={ROUTES.LOGIN} />} />
                  </Routes>
                </UserContextProvider>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </AppContextProvider>
  )
}

export default App
